import PropTypes from 'prop-types';
import ImageSwitcher from 'ui/layouts/ImageSwitcher';
import types from 'utils/personalities';

const CharacterPageBackground = ({ group, ...attrs }) => {
  const baseSrc = `/images/backgrounds/${group}`;

  return <ImageSwitcher baseSrc={baseSrc} alt={group} {...attrs}/>;
};
CharacterPageBackground.propTypes = {
  group: PropTypes.oneOf(Object.keys(types)).isRequired,
};

export default CharacterPageBackground;
